/**
 * Created by Mark on 18/04/2017.
 */


/**
 * Created by Mark on 18/04/2017.
 */


import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Table , Alert , FormGroup , FormControl, Row, Col } from 'react-bootstrap';
import autosize from 'autosize';
import StudentServices from '../../../services/student-services.js';
import InternationalizationStore from '../../../store/internationalization-store.js'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group' // ES6


class AddStudents extends React.Component {

    constructor(props){
        super();
        this.props = props;
        this.state = {
             students:{},
        };


        this.props.data.students = this.props.data.students || {};
        this.handelAddStudents = this.handelAddStudents.bind(this);
    }

    getExistingStudents(studentNames , studentObjects) {

        
        
        this.props.data.totalConflits = 0;
        return StudentServices.getExistingStudents(studentNames).then(function(response) {

            for(var key in studentObjects)
            {   
                console.log(studentObjects[key]);

                if(!studentObjects.hasOwnProperty(key)) continue;

                studentObjects[key].conflictStudents = [];

                for(var idx = 0 ; idx < response.length; idx++)
                {
                    console.log(String(response[idx].name).trim().toLowerCase() == String(studentObjects[key].name).trim().toLowerCase());
                    if(studentObjects[key].state == "create" && String(response[idx].name).trim().toLowerCase() == String(studentObjects[key].name).trim().toLowerCase())
                    {
                        studentObjects[key].conflict = true;
                        this.props.data.totalConflits++;
                        studentObjects[key].conflictStudents.push(response[idx]);
                    }
                }
            }

            return studentObjects
        }.bind(this))
    }

    getStudentsLength(){
        return Object.keys(this.props.data.students).length;
    }

    handelAddStudents(e){
        var students = this.state.students;
        var studentNames = e.target.value.split(/\r?\n/);
        var uniqueStudentNames = [];

        if(Number(this.getStudentsLength()) > Number(studentNames.length - 1))
        {
            for(var key in students)
            {
                if(!students.hasOwnProperty(key)) continue;
                if(Number(key) > Number(studentNames.length - 1)) delete students[key];
                if(studentNames[Number(studentNames.length - 1)].length == 0) delete students[key];
            }
        }


        for (var idx = 0; idx < studentNames.length; idx++) {
            var name = String(studentNames[idx]).replace(/\t/g, ' ').trim();

            if (name.length > 0){
                if(!students[idx]) students[idx] = {uid:null , name:name , state:'create'};
                else
                {
                    if(String(students[idx].name).toLowerCase() != String(name).toLowerCase())
                    {
                        students[idx] = {uid:null , name:name , state:'create'};
                    }
                }
            }

            if(uniqueStudentNames.indexOf(name.toLowerCase()) == -1) uniqueStudentNames.push(name.toLowerCase());
        }

        this.props.data.studentNumber = students.length;
        autosize(e.target);

        this.getExistingStudents(uniqueStudentNames , students).then(function(students){
            this.props.data.students = students;
            this.setState({studentNumber:this.props.data.studentNumber});
        }.bind(this));

    }

    resolveConflict(id , uid , action){
        this.props.data.students[id].state     = action;
        this.props.data.students[id].uid       = uid;
        this.props.data.students[id].conflict  = false;
        this.setState({update:true});
    }

    render(){


        this.input = <FormGroup className="fg-line fg-toggled"><FormControl autoFocus placeholder={InternationalizationStore.getTranslation('ui-455' , 'Paste ot type your class list here one name per line')} componentClass="textarea" onChange={this.handelAddStudents.bind(this)}/></FormGroup>

        const rows = Object.keys(this.props.data.students).map(function(key){
            var student = this.props.data.students[key];

            if(student.conflict == true)
            {
                var dom = [];

                console.log(student);
                for(var idx = 0 ; idx < student.conflictStudents.length; idx++)
                {
                    var conflictStudent = student.conflictStudents[idx];
                    let _new  = <button className="btn btn-block btn-primary"  onClick={this.resolveConflict.bind(this , key , conflictStudent.uid ,'add')}><FormattedMessage id={ 'ui-868' } defaultMessage={ 'Existing Student' }/></button>
                    
                    let _add = <button className="btn btn-block btn-primary"   onClick={this.resolveConflict.bind(this , key , conflictStudent.uid ,'new')} ><FormattedMessage id={ 'ui-459' } defaultMessage={ 'New Student' }/></button>



                    var classes = [];
                    for(var jdx = 0 ; jdx < conflictStudent.classes.length; jdx++)
                    {
                        //classes.push(<span className="palette-White text">{conflictStudent.classes[jdx].name}</span>);
                    }

                    dom.push(<Alert className="palette-Branding red bg" key={"conflict"+key+'-'+idx}><Table  className="palette-Branding red bg"><thead  className="p-0"><tr ><th className="p-0 b-b-0 palette-Branding red bg"><span className="palette-White text"><i className="palette-White text zmdi zmdi-alert-circle-o"></i> {student.name}</span></th><th  className="p-0 b-b-0 palette-Branding red bg">{classes}</th><th  className="p-5 b-b-0 palette-Branding red bg">{_new}</th><th  className="p-5 b-b-0 palette-Branding red bg">{_add}</th></tr></thead></Table></Alert>)

                }

                return dom
            }
            else
            {
                return null;
            }

        }.bind(this));


        return <div className="p-b-20">
                    <Row>
                        <Col sm={12}>{this.input}</Col>
                    </Row>
                    <Row>
                        <ReactCSSTransitionGroup transitionName="example" transitionAppearTimeout={500} transitionAppear={true} transitionEnterTimeout={500} transitionLeaveTimeout={300}>
                            {rows}
                        </ReactCSSTransitionGroup>
                    </Row>
                </div>
    }
}
export default {
    name: <FormattedMessage id={ 'ui-903' } defaultMessage={ 'Create New Students' }/>,
    title:null,
    handelError:true,
    onSubmit: function (done){


        if(Object.keys(this.props.data.students).length == 0)
        {
            return done(new Error(InternationalizationStore.getTranslation('ui-342' ,'You need to enter students to continue' )));
        }

        for(var key in this.props.data.students) {
            var student = this.props.data.students[key];
            if (student.conflict == true) return done(new Error(InternationalizationStore.getTranslation('ui-342', 'You need to enter students to continue')));

        }

        done();
    },

    component: AddStudents
}



// WEBPACK FOOTER //
// ./src/components/wizard/create-class-steps/add-students.js